import { render, staticRenderFns } from "./FormTextAreaReadonly.vue?vue&type=template&id=f899bfdc&"
import script from "./FormTextAreaReadonly.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports